export default {
  gewerbe: {
    hero: {
      eyebrow: 'Poslovni korisnici',
      title: 'Profesionalni videonadzor za poslovne potrebe',
      lead: 'Od maloprodajne poslovnice do proizvodne hale – planiramo, ugrađujemo i održavamo sustave kamera koji služe vašem poslovanju. Uz poštivanje privatnosti, skalabilno i pouzdano.',
    },
    types: {
      title: 'Rješenja za vaše poslovanje',
      lead: 'Svaka branša ima vlastite zahtjeve. Poznajemo tipične izazove i planiramo u skladu s tim.',
      items: {
        '0': { title: 'Trgovine i dućani', desc: 'Ulaz, prodajni prostor, blagajna i skladište – diskretno, ali učinkovito nadzirano. Zaštita od krađe i vandalizma.', tags: { '0': 'Unutra', '1': 'Zaštita od krađe', '2': 'Blagajna' } },
        '1': { title: 'Uredi i ordinacije', desc: 'Recepcija, hodnici, osjetljiva područja i parkirališta, s pravima pristupa i privatnim zonama.', tags: { '0': 'Unutra', '1': 'Recepcija', '2': 'Privatnost' } },
        '2': { title: 'Skladište i logistika', desc: 'Nadzor velikih površina širokokutnim i PTZ kamerama. Pregled zona isporuke, polica i vanjskih površina danju i noću.', tags: { '0': 'Unutra', '1': 'Vani', '2': 'Noćni vid' } },
        '3': { title: 'Ugostiteljstvo', desc: 'Ulaz, šank, pristup kuhinji i vanjski prostor – robusne kamere za vlažna i vruća okruženja.', tags: { '0': 'Unutra', '1': 'Vani', '2': 'Robusno' } },
        '4': { title: 'Radionice i industrija', desc: 'Zahtjevnija okruženja traže posebno robusne kamere. Radionice, vanjski prostori i zone utovara zaštićeni.', tags: { '0': 'Unutra', '1': 'Robusno', '2': 'Noćni vid' } },
        '5': { title: 'Više lokacija', desc: 'Centralni pristup svim kamerama putem jedne aplikacije. Upravljanje korisnicima s različitim pravima.', tags: { '0': 'Više lokacija', '1': 'Centralno', '2': 'Aplikacija' } },
      },
    },
    features: {
      title: 'Funkcije za poslovnu upotrebu',
      lead: 'Poslovne instalacije zahtijevaju više od kamera. Profesionalno postavljamo prava, planove snimanja i obavijesti.',
      items: {
        '0': { title: 'Upravljanje korisnicima', desc: 'Različita prava pristupa za zaposlenike, voditelje poslovnica i upravu. Tko smije vidjeti koju kameru?' },
        '1': { title: 'Snimanje i arhiviranje', desc: 'Lokalni snimač s redundantnom pohranom. Trajanje prema poslovnim i eventualno zakonskim zahtjevima.' },
        '2': { title: 'Obavijesti o događajima', desc: 'Push poruke kod kretanja, prelaska linije ili definiranih događaja, ovisno o sustavu.' },
        '3': { title: 'Proširivost', desc: 'Vaše poslovanje raste? Postojeći sustavi obično se mogu proširiti kamerama i lokacijama.' },
      },
    },
    legal: {
      eyebrow: 'Zaštita podataka i pravo',
      title: 'Poslovni videonadzor usklađen s propisima',
      lead: 'Za komercijalni videonadzor vrijede dodatna pravila, posebno u vezi zaposlenika, kupaca i javnih površina. Podržavamo vas u tehničkoj provedbi:',
      list: {
        '0': 'Transparentnost i oznake na ulazima',
        '1': 'Maskiranje garderoba i prostorija za odmor',
        '2': 'Tehnička provedba prava pristupa i upravljanja korisnicima',
        '3': 'Lokalna pohrana s definiranim rokom čuvanja',
        '4': 'Dokumentacija poslovne nužnosti',
      },
      note: 'Napomena: zakonska dopuštenost poslovnog videonadzora ovisi o slučaju. Savjetujemo vas tehnički, ne zamjenjujući pravni savjet.',
    },
    cta: {
      title: 'Vaše poslovanje zaslužuje profesionalnu sigurnost',
      lead: 'Analiziramo vaše procese i planiramo sustav koji štiti bez ometanja. Bez obveze i transparentno.',
      primary: 'Zakažite termin savjetovanja',
      secondary: 'Otkrijte SSG Care',
    },
  },
};